require('./helpers/bundle-manifest').register(JSON.parse("{\"lE500\":\"about.b02b0e07.js\",\"6axnP\":\"SquareLogo8.0e25e814.svg\"}"));